<template>
    <v-container fluid>
        <v-row dense>
            <v-col cols="12" md="12">
                <v-card :elevation="1">
                    <v-card-text class="py-1">
                        <v-row dense>
                            <v-col cols="12" md="3">
                                <v-select
                                    label="Tr. Type"
                                    dense
                                    outlined
                                    hide-details
                                    :items="['All','Salary Advance', 'Deduction', 'Benefit']"
                                    class="mb-1 custom-form"
                                    v-model="filter.tr_type"
                                ></v-select>
                            </v-col>

                            <v-col cols="12" md="3">
                                <v-combobox
                                    label="Employee"
                                    dense
                                    outlined
                                    hide-details
                                    :items="employees"
                                    :loading="employee_loading"
                                    v-model="selectedEmployee"
                                    item-text="display_name"
                                    item-value="id"
                                    class="mb-1 custom-form"
                                    @focus="getEmployees"
                                ></v-combobox>
                            </v-col>

                            <v-col cols="12" md="2">
                                <v-menu
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                    v-model="menu"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            dense
                                            outlined
                                            hide-details
                                            v-model="filter.date_from"
                                            label="Date From"
                                            v-on="on"
                                            class="custom-form"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="filter.date_from" @input="menu = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            
                            <v-col cols="12" md="2">
                                <v-menu
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                    v-model="menu2"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            dense
                                            outlined
                                            hide-details
                                            v-model="filter.date_to"
                                            label="Date To"
                                            v-on="on"
                                            class="custom-form"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="filter.date_to" @input="menu2 = false"></v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col cols="12" md="2">
                                <v-btn
                                    elevation="1"
                                    small
                                    color="primary"
                                    dark
                                    style="margin-top:-2px"
                                    @click="getRecords"
                                > Search </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12">
                <v-toolbar dense color="white" :elevation="1" height="30px">
                    <v-toolbar-title class="subtitle-2">Transaction Record</v-toolbar-title>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row v-if="records.length > 0">
            <v-col cols="12">
                <v-btn
                    color="primary"
                    class="white--text"
                    small
                    dense
                    @click="print"
                >
                    <v-icon left small dense> mdi-printer </v-icon>
                    Print
                </v-btn>
            </v-col>
            <v-col cols="12" md="12" class="py-1" id="reportContent">
                <v-simple-table dense class="record_table">
                    <tr class="record_heading_tr">
                        <th>SL.</th>
                        <th>Tr. ID</th>
                        <th>Date</th>
                        <th>Employee</th>
                        <th>Tr. Type</th>
                        <th>Amount</th>
                        <th>Process By</th>
                        <th>Remark</th>
                        <th>Action</th>
                    </tr>
                    <tr v-for="(record, sl) in records" :key="sl">
                        <td>{{++sl}}</td>
                        <td>{{record.code}}</td>
                        <td>{{record.date}}</td>
                        <td>{{record.emp_id}} - {{record.employee_name}}</td>
                        <td>{{record.tr_type}}</td>
                        <td>{{record.amount}}</td>
                        <td>{{record.process_by_name}}</td>
                        <td>{{record.remark}}</td>
                        <td>
                            <v-tooltip bottom v-if="$store.state['user'].role != 'User' && !record.salary_id">
                                <template v-slot:activator="{ on }">
                                    <v-btn icon id="no-background-hover" :to="'/transaction/'+record.id">
                                        <v-icon small color="primary" v-on="on">mdi-circle-edit-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Edit</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="$store.state['user'].role == 'Admin' && !record.salary_id">
                                <template v-slot:activator="{ on }">
                                    <v-icon small color="error" v-on="on" @click="deleteTransaction(record.id)">mdi-delete-circle-outline</v-icon>
                                </template>
                                <span>Delete</span>
                            </v-tooltip>
                        </td>
                    </tr>
                    <tr>
                        <th style="text-align: right;" colspan="5">Total=</th>
                        <th>
                            {{records.reduce((prev, curr) => {return prev + +curr.amount}, 0)}}
                        </th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import utility from '../../mixins/utility.mixin';
export default {
    mixins: [utility],
    data() {
        return {
            filter: {
                date_from  : this.toISOLocal().substr(0, 10),
                date_to    : this.toISOLocal().substr(0, 10),
                employee_id: null,
                tr_type    : 'All',
            },
            employees       : [],
            selectedEmployee: null,
            records         : [],
            employee_loading: false,
            menu            : false,
            menu2           : false,
        }
    },
    watch: {
        selectedEmployee(emp){
            this.filter.employee_id = null;
            if(!emp || emp.id == undefined){
                return;
            }
            this.filter.employee_id = emp.id;
        },
        
    },
    created() {
    },

    methods: {
        async getEmployees(){
            this.employee_loading = true;
            this.employees = await this.$store.dispatch('employee/getEmployees', {
                apiParams: {},
                options: {
                    returnData: true
                }
            });
            this.employee_loading = false;
        },
        async getRecords() {
            this.records = await this.$store.dispatch('transaction/getTransactions', {
                apiParams: this.filter,
                options: {
                    returnData : true
                }
            })
        },
        async deleteTransaction(id){
            if (!confirm("Are you sure?")) return;

            await this.$store.dispatch("transaction/deleteTransaction", id);
            this.getRecords();
        },
        async print(){
            let title = 'Transaction Record ('+this.filter.date_from+' to '+this.filter.date_to+')';

            let company_profile = this.$store.getters['company/company'];

            // Get HTML to print from element
            const prtHtml = document.getElementById('reportContent').innerHTML;

            // Get all stylesheets HTML
            let stylesHtml = '';
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML;
            }

            // Open the print window
            // const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            const WinPrint = window.open('', 'PRINT', `height=${screen.height}, width=${screen.width}`);
            WinPrint.document.write(`<!DOCTYPE html>
            <html>
            <head>
                ${stylesHtml}
            </head>
            <body>
                <div data-app="true" class="v-application v-application--is-ltr theme--light" id="app">
                    <div class="container container--fluid">
                        <div class="row row--dense">
                            <div class="col-2 px-2">
                                <img style="width: 100%; height: 50px;" src="${this.$store.state.host+company_profile.logo}">
                            </div>
                            <div class="col-8 px-2 text-center">
                                <span class="font-weight-black">
                                    ${company_profile.name}
                                </span>
                                <br>
                                <span>${company_profile.address}</span>
                                <br>
                                <span>
                                    Email:${company_profile.email}, Contact:${company_profile.phone}
                                </span>
                            </div>
                            <div class="col-2 px-2">
                                <img style="width: 100%; height: 50px;" src="${this.$store.state.host+'linkup.png'}">
                            </div>
                            <div class="col-12 px-2 text-center">
                                <p class="font-weight-black custom_header">
                                    ${title}
                                </p>
                            </div>
                            <div class="col col-12 px-2">
                                ${prtHtml}
                            </div>
                        </div>
                    </div>
                </div>
            </body>
            </html>`);

            WinPrint.document.head.innerHTML += `
                <style>
                    .v-data-table__wrapper{
                        overflow: unset;
                    }
                    .record_heading_tr th{
                        text-align: center !important;
                    }
                    .custom_header{
                        background-color: #0000001f;
                        border-radius: 4px;
                        margin-bottom: 5px !important;
                    }
                    tr:hover{
                        background: unset !important;
                    }
                    .record_heading_tr:hover{
                        background: #4caf7773 !important;
                    }
                    @media print {
                        table.record_table { page-break-after:auto }
                        table.record_table tr    { page-break-inside:avoid; page-break-after:auto }
                        table.record_table td    { page-break-inside:avoid; page-break-after:auto }
                        table.record_table thead { display:table-header-group }
                        table.record_table tfoot { display:table-footer-group }
                    }
                </style>
            `;

            let rows = WinPrint.document.querySelectorAll('.record_table tr');
            rows.forEach(row => {
                row.lastChild.remove();
            })

            WinPrint.focus();
            WinPrint.document.close();
            await new Promise(resolve => setTimeout(resolve, 2000));
            WinPrint.print();
            WinPrint.close();
        }
    },
}
</script>

<style scoped>
    .record_table{
        margin-bottom: 5px;
    }
    .record_table table, .record_table th, .record_table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        padding: 0 !important;
        
    }
    .record_table th, .record_table td {
        padding: 2px !important;
        font-size: 11px !important;
        text-align: center;
        height: 0 !important;
    }
    .record_heading_tr{
        background: #4caf7773;
    }

    #no-background-hover::before {
        background-color: transparent !important;
    }

    >>>.v-btn--icon.v-size--default{
        height: unset;
        width: unset;
    }

    >>>.v-btn--icon.v-size--default .v-icon{
        height: unset;
        width: unset;
    }
</style>